export const CREATE_SHORT_EXCESS = 'CREATE_SHORT_EXCESS';
export const GET_SHORT_EXCESS = 'GET_SHORT_EXCESS';
export const SHORT_EXCESS_REQUEST = 'SHORT_EXCESS_REQUEST';
export const UPDATE_SHORT_EXCESS = 'UPDATE_SHORT_EXCESS';
export const DELETE_SHORT_EXCESS = 'DELETE_SHORT_EXCESS';
export const SHORT_EXCESS_REQUEST_FAILURE = 'SHORT_EXCESS_REQUEST_FAILURE';
export const GET_SHORT_EXCESS_PAGE = 'GET_SHORT_EXCESS_PAGE';
export const SHORT_EXCESS_REQUEST_SUCCESS = 'SHORT_EXCESS_REQUEST_SUCCESS';
